import styless from "./Spinner.module.less";
const Spinner = () => (
  <div>
    <div className={styless.spinners}></div>
  </div>
);

export default Spinner;
